import Chart from 'chart.js/auto'

  (async function () {
    new Chart(
      document.getElementById('freqs'),
      {
        type: 'line',
        data: {
          datasets: [
            {
              label: "(38 шт) BMX 300-6SMD \"БУМБОКС\"",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 420, y: 38 }, { x: 520, y: 38 },
                { x: 520, y: 0 }, { x: 720, y: 0 },
                { x: 720, y: 38 }, { x: 1070, y: 38 },
                { x: 1070, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 38 }, { x: 2484, y: 38 },
                { x: 2484, y: 0 }, { x: 5725, y: 0 },
                { x: 5725, y: 38 }, { x: 5850, y: 38 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(28 шт) РЕБ УДАВ А4, UKRMT 5.00.000",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 400, y: 28 }, { x: 500, y: 28 },
                { x: 500, y: 0 }, { x: 700, y: 0 },
                { x: 700, y: 28 }, { x: 1000, y: 28 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(27 шт) Кульбаба К 161.001",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 710, y: 27 }, { x: 1010, y: 27 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(27 шт) Кульбаба К 161.002",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 300, y: 27 }, { x: 410, y: 27 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(27 шт) Кульбаба К 161.003",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 410, y: 27 }, { x: 560, y: 27 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(23 шт) STR ШАТРО 50-1.5800",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 5725, y: 23 }, { x: 5850, y: 23 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(19 шт) STR Шатро №7 (500,600,700,800,50-1,1000,2400)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 500, y: 19 }, { x: 1000, y: 19 },
                { x: 1000, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 19 }, { x: 2484, y: 19 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(19 шт) РЕБ УДАВ А10, UKRMT 16.00.000",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 1800, y: 19 }, { x: 2800, y: 19 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(18 шт) РЕБ УДАВ O6",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 400, y: 18 }, { x: 500, y: 18 },
                { x: 500, y: 0 }, { x: 700, y: 0 },
                { x: 700, y: 18 }, { x: 1000, y: 18 },
                { x: 1000, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 18 }, { x: 2500, y: 18 },
                { x: 2500, y: 0 }, { x: 5725, y: 0 },
                { x: 5725, y: 18 }, { x: 5850, y: 18 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(15 шт) STR ШАТРО 50-1.400",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 320, y: 15 }, { x: 420, y: 15 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(14 шт) STR ШАТРО 50-1.300",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 220, y: 14 }, { x: 320, y: 14 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(14 шт) SKY Wiper OMNI MAX",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 300, y: 14 }, { x: 1020, y: 14 },
                { x: 1020, y: 0 }, { x: 2100, y: 0 },
                { x: 2100, y: 14 }, { x: 2700, y: 14 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(12 шт )STR Шатро №5 (500.600.700.800.50-1)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 500, y: 12 }, { x: 900, y: 12 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(10 шт) \"РА34\"(300 - 400 MHz, потужність 50W)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 300, y: 10 }, { x: 400, y: 10 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(10 шт) STR ШАТРО 50-1.2100-2250",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 2100, y: 10 }, { x: 2250, y: 10 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(10 шт) STR ШАТРО 50-1.2250-2400",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 2250, y: 10 }, { x: 2400, y: 10 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(10 шт) STR ШАТРО 50-1.2550-2700",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 2550, y: 10 }, { x: 2700, y: 10 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(10 шт) STR ШАТРО №6 (500; 600; 700; 800; 50-1; 1000;)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 500, y: 10 }, { x: 1000, y: 10 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(9 шт) STR ШАТРО №8 (300; 400; 500; 600; 700; 800; 50-1; 1000)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 300, y: 9 }, { x: 1000, y: 9 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(7 шт) \"PARASoL\" 2 (400 / 500 / 700)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 400, y: 7 },
                { x: 401, y: 0 }, { x: 499, y: 0 },
                { x: 500, y: 7 },
                { x: 501, y: 0 }, { x: 699, y: 0 },
                { x: 700, y: 7 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(7 шт) \"HYMO М\"(4 дiапазони)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 400, y: 7 }, { x: 600, y: 7 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(7 шт) BMX 250 - 5MSD \"БУМБОКС\"",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 720, y: 7 }, { x: 1060, y: 7 },
                { x: 1060, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 7 }, { x: 2485, y: 7 },
                { x: 2485, y: 0 }, { x: 5725, y: 0 },
                { x: 5725, y: 7 }, { x: 5850, y: 7 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(6 шт) \"PARASoL\" 2 (800 / 1000 / 2400)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 800, y: 6 },
                { x: 801, y: 0 }, { x: 999, y: 0 },
                { x: 1000, y: 6 },
                { x: 1001, y: 0 }, { x: 2399, y: 0 },
                { x: 2400, y: 6 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(6 шт) \"НYМО-L\"(6 дiапазонів)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 600, y: 6 }, { x: 650, y: 6 },
                { x: 650, y: 0 }, { x: 700, y: 0 },
                { x: 700, y: 6 }, { x: 775, y: 6 },
                { x: 775, y: 6 }, { x: 1100, y: 6 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(5 шт) \"РА23\"(200 - 300 MHz, потужність 50W)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 200, y: 5 }, { x: 300, y: 5 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(4 шт) STR ШАТРО 100-1.2300-2500",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 2300, y: 4 }, { x: 2500, y: 4 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(4 шт) STR Шатро №5 (700.800.1000.2400.50-1)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 700, y: 4 }, { x: 1000, y: 4 },
                { x: 1000, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 4 }, { x: 2485, y: 4 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(3 шт) РЕБ \"ДАМБА\"",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 500, y: 3 }, { x: 2700, y: 3 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(3 шт) STR ШАТРО 50-1.500",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 420, y: 3 }, { x: 520, y: 3 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(2 шт) КВЕРТУС AD COUNTER FPV F2 700+900 M30",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 700, y: 2 }, { x: 940, y: 2 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(2 шт) КВЕРТУС AD COUNTER FPV F2 700+1000 M30",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 700, y: 2 }, { x: 850, y: 2 },
                { x: 850, y: 0 }, { x: 940, y: 0 },
                { x: 940, y: 2 }, { x: 1050, y: 2 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(2 шт) КВЕРТУС AD KRAKEN U",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 700, y: 2 }, { x: 1050, y: 2 },
                { x: 1050, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 2 }, { x: 2500, y: 2 },
                { x: 2500, y: 0 }, { x: 5700, y: 0 },
                { x: 5700, y: 2 }, { x: 5900, y: 2 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(2 шт) \"HYMO- M\" 4 - ре діапазони 700-1000",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 700, y: 2 }, { x: 1000, y: 2 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) \"HYMO- M\" 4 - ре діапазони 400 - 600",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 400, y: 1 }, { x: 600, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR Шатро №5 (800.1000.2400.5800.50- 1) ",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 800, y: 1 }, { x: 1000, y: 1 },
                { x: 1000, y: 0 }, { x: 2400, y: 0 },
                { x: 2400, y: 1 }, { x: 2485, y: 1 },
                { x: 2485, y: 0 }, { x: 5800, y: 0 },
                { x: 5800, y: 1 }, { x: 5850, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) КВЕРТУС AD COUNTER FPV",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 850, y: 1 }, { x: 940, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) Квертус AD COUNTER FPV BACKPACK 8113 / 3110",
              fill: {
                target: 'origin',
                above: 'rgba(0, 0, 255, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 0, 255, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 850, y: 1 }, { x: 940, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО №9 (300; 400; 500; 600; 700; 800; 50-1; 1000; 2100-2300)",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 300, y: 1 }, { x: 1000, y: 1 },
                { x: 1000, y: 0 }, { x: 2100, y: 0 },
                { x: 2100, y: 1 }, { x: 2300, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) OBRIY ANTI-FPV AUTO QUADRO",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 360, y: 1 }, { x: 480, y: 1 },
                { x: 410, y: 1 }, { x: 580, y: 1 },
                { x: 580, y: 0 }, { x: 700, y: 0 },
                { x: 700, y: 1 }, { x: 1000, y: 1 },
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1.600",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 520, y: 1 }, { x: 620, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1.700",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 620, y: 1 }, { x: 720, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1.800",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 720, y: 1 }, { x: 820, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 850, y: 1 }, { x: 940, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1.1000",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 950, y: 1 }, { x: 1070, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "(1 шт) STR ШАТРО 50-1.2400",
              fill: {
                target: 'origin',
                above: 'rgba(0, 255, 0, 0.5)',
              },
              borderWitdh: 0,
              borderColor: 'rgba(0, 255, 0, 0.5)',
              lineJoin: "none",
              pointStyle: false,
              data: [
                { x: 2400, y: 1 }, { x: 2485, y: 1 }
              ],
              yAxisID: 'y1',
              hidden: true,
            },
            {
              label: "Статистика Спектрофай-D 01.01.2026-12.02.2026",
              fill: {
                target: 'origin',
                above: 'rgb(255, 0, 0)',
              },
              borderColor: 'rgb(255, 0, 0)',
              borderWitdh: 0,
              lineJoin: "round",
              pointStyle: false,
              order: 1000,
              data: [
                { x: 300, y: 2 }, { x: 400, y: 2 },
                { x: 400, y: 711 }, { x: 700, y: 711 },
                { x: 700, y: 87 }, { x: 800, y: 87 },
                { x: 800, y: 1138 }, { x: 1020, y: 1138 },
                { x: 1020, y: 0 }, { x: 1910, y: 0 },
                { x: 1910, y: 344 }, { x: 2300, y: 344 },
                { x: 2300, y: 438 }, { x: 2400, y: 438 },
                { x: 2400, y: 753 }, { x: 2705, y: 753 },
              ],
              yAxisID: 'y',
            },
          ]
        },
        options: {
          interaction: {
            mode: 'index',
            intersect: false,
          },
          responsive: true,
          datasets: {
            line: {
              pointRadius: 0 // disable for all `'line'` datasets
            }
          },
          scales: {
            x: {
              title: {
                color: 'black',
                display: true,
                text: 'Частота, МГц'
              },
              type: 'logarithmic',
              min: 180,
              max: 6000
            },
            y: {
              title: {
                color: 'black',
                display: true,
                text: 'Кількість сигналів, логарифмічна шкала'
              },
              position: 'left',
              type: 'logarithmic',
              //type: 'linear',
              min: 0,
              max: 1200
            },
            y1: {
              title: {
                color: 'black',
                display: true,
                text: 'Кількість засобів'
              },
              type: 'linear',
              display: true,
              position: 'right',
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
              min: 0,
              max: 40
            },
          }
        }
      }
    );
  })();
